import { render, staticRenderFns } from "./FormDisposal.vue?vue&type=template&id=0c765768&scoped=true"
import script from "./FormDisposal.vue?vue&type=script&lang=js"
export * from "./FormDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c765768",
  null
  
)

export default component.exports